export default __webpack_public_path__ + "static/media/art-bottomless1.c6835c44.jpg";